export default __webpack_public_path__ + "static/media/img_access_denied.8f3c6465.png";